import type { UseThirdPartyPartnersFetchHook } from '@openx/components-deal/lib/utils/context/DealHookTypes';
import type { ThirdPartyPartnerOptionApi } from '@openx/types/options';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../../hooks/useOptionsByPathQuery';

export const useThirdPartyPartnersFetch: UseThirdPartyPartnersFetchHook = accountUid => {
  const { data, loading } = useOptionsByPathQuery({
    skip: !accountUid,
    variables: {
      filter: { account_uid: accountUid },
      path: 'deal.third_party_partners_options',
    },
  });

  const mapById = useMemo(() => {
    if (!data?.optionsByPath) {
      return {};
    }

    return data.optionsByPath.reduce<Record<string, ThirdPartyPartnerOptionApi>>((acc, optionByPath) => {
      if (optionByPath) {
        acc[optionByPath.id] = { id: optionByPath.id, name: optionByPath.name, ...optionByPath.extra };
      }

      return acc;
    }, {});
  }, [data?.optionsByPath]);

  return {
    loading,
    mapById,
  };
};
